<template>
    <div>
        <div class="search-box">
            <p>学年：</p>
            <a-date-picker
                class="input-box"
                mode="year"
                format='YYYY'
                v-model="year" 
                :open='yearShowOne' 
                @openChange="openChangeOne"
                @panelChange="panelChangeOne">
                <a-input  v-model="searchFrom.schoolYear" />
            </a-date-picker>
            <p>教师姓名或编号：</p>
            <a-input class="input-box" v-model="searchFrom.teacherIdOrName" />
            <p>职称：</p>
            <a-select class="input-box" allowClear v-model="searchFrom.technicalTitleCode">
                <a-select-option v-for="(item,index) in zcArr" :key="index" :value="item.dataCode">{{item.dataName}}</a-select-option>
            </a-select>
            <p>申诉状态：</p>
            <a-select class="input-box" allowClear v-model="searchFrom.complaintStatus">
                <a-select-option key="commit" value="commit">申诉中</a-select-option>
                <a-select-option key="replied" value="replied">已回复</a-select-option>
            </a-select>
            <p>确认状态：</p>
            <a-select class="input-box" allowClear v-model="searchFrom.confirmStatus">
                <a-select-option key="N" value="N">未确认</a-select-option>
                <a-select-option key="Y" value="Y">已确认</a-select-option>
            </a-select>
            <a-button type="primary" icon="search" @click="searchList">搜索</a-button>
        </div>
        <div class="operation-box">
            <a-button 
                type="primary"
                icon="plus" 
                class="btn" 
                @click="$router.push('/admin/faculty/allowance/info?type=add')"
                v-if="permissions.indexOf('faculty:assess:add')>-1">
                 新增
            </a-button>
            <a-popconfirm placement="top" title="确定删除？" ok-text="确定" cancel-text="取消" @confirm="selectedRowKeys[0] == null ? selectedCheck() :remove(selectedRowKeys[0])">
                <a-button
                    v-if="permissions.indexOf('faculty:assess:delete')>-1"
                    type="primary"
                    icon="minus" 
                    class="btn" 
                    >
                    删除
                </a-button>
            </a-popconfirm>
            <a-button 
                type="primary"
                icon="edit" 
                class="btn" 
                @click="selectedRowKeys[0] == null ? selectedCheck() : $router.push('/admin/faculty/allowance/info?type=edit&id='+selectedRowKeys[0])"
                v-if="permissions.indexOf('faculty:assess:edit')>-1">
                 编辑
            </a-button>
            <a-button
                type="primary"
                icon="file-search" 
                class="btn" 
                v-if="permissions.indexOf('faculty:assess:query')>-1"
                @click="selectedRowKeys[0] == null ? selectedCheck() : $router.push('/admin/faculty/allowance/info?type=look&id='+selectedRowKeys[0])"
                >
                 查看详情
            </a-button>
            <a-button
                type="primary"
                icon="backward" 
                class="btn"
                v-if="permissions.indexOf('faculty:assess:cancel')>-1" 
                @click="selectedRowKeys[0] == null ? selectedCheck() : cancel(selectedRowKeys[0],searchFrom.schoolYear)"
                >
                 取消确认
            </a-button>
            <a-button
                type="primary"
                icon="export" 
                class="btn"
                v-if="permissions.indexOf('faculty:assess:export')>-1" 
                @click="exportExcel()"
                >
                 导出
            </a-button>
        </div>
        
        <a-table
            rowKey='id'
            :customRow="onClickRow"
            :columns="columns" 
            :data-source="data" 
            :loading="loading"
            :pagination="pagination"
            @change="handleTableChange"
            :scroll="{ x :'500px' }"
            :row-selection="{ type:'radio',selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
            bordered>
        </a-table>
    </div>
</template>
<script>
    import { getDicts } from '@/baseAPI/dictionary'
    import { list,del,cancel,exportExcel } from '@/baseAPI/allowance'
    import { getSchoolYear,selectedCheck } from '@/baseAPI/util'

    export default {
        name: 'teacher',
        data () {
            return {
                columns:[
        {
            title: '序号',
            align:'center',
            width:80,
            fixed: 'left',
            customRender: (text, row, index) => {
                if(row.teachU+row.teachG+row.teachD < row.minTeach || row.resScore < row.minResearch || row.serviceScore < row.minService){
                    return <p style='color:red'> {index+1} </p>
                }
                return { children: index+1};
            },
        },
        {
            title: '学年',
            dataIndex: 'schoolYear',
            align:'center',
            fixed: 'left',
            width:150,
            customRender: (text, row, index) => {
                if(row.teachU+row.teachG+row.teachD < row.minTeach || row.resScore < row.minResearch || row.serviceScore < row.minService){
                    return <p style='color:red'> {text} </p>
                }
                return text
            },
        },
        {
            title: '部门',
            dataIndex: 'orgName',
            align:'center',
            fixed: 'left',
            width:120,
            customRender: (text, row, index) => {
                if(row.teachU+row.teachG+row.teachD < row.minTeach || row.resScore < row.minResearch || row.serviceScore < row.minService){
                    return <p style='color:red'> {text} </p>
                }
                return text
            },
        },
        {
            title: '姓名',
            dataIndex: 'teacherName',
            align:'center',
            fixed: 'left',
            width:120,
            customRender: (text, row, index) => {
                if(row.teachU+row.teachG+row.teachD < row.minTeach || row.resScore < row.minResearch || row.serviceScore < row.minService){
                    return <p style='color:red;'> {text} </p>
                }
                return text
            },
        },
        {
            title: '职称',
            dataIndex: 'technicalTitleName',
            align:'center',
            fixed: 'left',
            width:100,
            customRender: (text, row, index) => {
                if(row.teachU+row.teachG+row.teachD < row.minTeach || row.resScore < row.minResearch || row.serviceScore < row.minService){
                    return <p style='color:red'> {text} </p>
                }
                return text
            },
        },
        {
            title: '岗位工作量津贴',
            dataIndex: 'postMoney',
            align:'center',
            sorter: (a, b) => a.postMoney - b.postMoney,
            width:150,
            customRender: (text, row, index) => {
                if(row.teachU+row.teachG+row.teachD < row.minTeach || row.resScore < row.minResearch || row.serviceScore < row.minService){
                    return <p style='color:red;text-align:right'> {text} </p>
                }
                return <p style='text-align:right'>{text}</p>
            },
        },
        {
            title: '规定基本工作量（最低值）',
            dataIndex: 'minWorkload',
            align:'center',
            sorter: (a, b) => a.minWorkload - b.minWorkload,
            width:170,
            customRender: (text, row, index) => {
                if(row.teachU+row.teachG+row.teachD < row.minTeach || row.resScore < row.minResearch || row.serviceScore < row.minService){
                    return <p style='color:red;text-align:right'> {text} </p>
                }
                return <p style='text-align:right'>{text}</p>
            },
        },
        {
            title: '总分',
            dataIndex: 'totalScore',
            align:'center',
            sorter: (a, b) => a.totalScore - b.totalScore,
            width:120,
            customRender: (text, row, index) => {
                if(row.teachU+row.teachG+row.teachD < row.minTeach || row.resScore < row.minResearch || row.serviceScore < row.minService){
                    return <p style='color:red;text-align:right'> {text} </p>
                }
                return <p style='text-align:right'>{text}</p>
            },
        },
        {
            title: '实际超工作量分',
            dataIndex: 'actualExcess',
            sorter: (a, b) => a.actualExcess - b.actualExcess,
            align:'center',
            width:130,
            customRender: (text, row, index) => {
                if(row.teachU+row.teachG+row.teachD < row.minTeach || row.resScore < row.minResearch || row.serviceScore < row.minService){
                    return <p style='color:red;text-align:right'> {text} </p>
                }
                return <p style='text-align:right'>{text}</p>
            },
        },
        {
            title: '超工作量金额(600元/分）',
            dataIndex: 'aeMoney',
            align:'center',
            sorter: (a, b) => a.aeMoney - b.aeMoney,
            width:160,
            customRender: (text, row, index) => {
                if(row.teachU+row.teachG+row.teachD < row.minTeach || row.resScore < row.minResearch || row.serviceScore < row.minService){
                    return <p style='color:red;text-align:right'> {text} </p>
                }
                return <p style='text-align:right'>{text}</p>
            },
        },
        {
            title: '非全日制教学费用',
            dataIndex: 'nonFt',
            align:'center',
            sorter: (a, b) => a.nonFt - b.nonFt,
            width:130,
            customRender: (text, row, index) => {
                if(row.teachU+row.teachG+row.teachD < row.minTeach || row.resScore < row.minResearch || row.serviceScore < row.minService){
                    return <p style='color:red;text-align:right'> {text} </p>
                }
                return <p style='text-align:right'>{text}</p>
            },
        },
        {
            title: '指导非全日制专硕费用',
            dataIndex: 'guidNonFt',
            align:'center',
            sorter: (a, b) => a.guidNonFt - b.guidNonFt,
            width:150,
            customRender: (text, row, index) => {
                if(row.teachU+row.teachG+row.teachD < row.minTeach || row.resScore < row.minResearch || row.serviceScore < row.minService){
                    return <p style='color:red;text-align:right'> {text} </p>
                }
                return <p style='text-align:right'>{text}</p>
            },
        },
        {
            title: '教学事故扣发',
            dataIndex: 'accident',
            align:'center',
            sorter: (a, b) => a.accident - b.accident,
            width:120,
            customRender: (text, row, index) => {
                if(row.teachU+row.teachG+row.teachD < row.minTeach || row.resScore < row.minResearch || row.serviceScore < row.minService){
                    return <p style='color:red;text-align:right'> {text} </p>
                }
                return <p style='text-align:right'>{text}</p>
            },
        },
        {
            title: '合计津贴/年',
            dataIndex: 'yearMoney',
            align:'center',
            sorter: (a, b) => a.yearMoney - b.yearMoney,
            width:120,
            customRender: (text, row, index) => {
                if(row.teachU+row.teachG+row.teachD < row.minTeach || row.resScore < row.minResearch || row.serviceScore < row.minService){
                    return <p style='color:red;text-align:right'> {text} </p>
                }
                return <p style='text-align:right'>{text}</p>
            },
        },
        {
            title: '每月实发',
            dataIndex: 'monthMoney',
            align:'center',
            sorter: (a, b) => a.monthMoney - b.monthMoney,
            width:150,
            customRender: (text, row, index) => {
                if(row.teachU+row.teachG+row.teachD < row.minTeach || row.resScore < row.minResearch || row.serviceScore < row.minService){
                    return <p style='color:red;text-align:right'> {text} </p>
                }
                return <p style='text-align:right'>{text}</p>
            },
        },
        {
            title: '规定本科教学基础教分（最低值）',
            dataIndex: 'minTeach',
            align:'center',
            sorter: (a, b) => a.minTeach - b.minTeach,
            width:190,
            customRender: (text, row, index) => {
                if(row.teachU+row.teachG+row.teachD < row.minTeach || row.resScore < row.minResearch || row.serviceScore < row.minService){
                    return <p style='color:red;text-align:right'> {text} </p>
                }
                return <p style='text-align:right'>{text}</p>
            },
        },
        {
            title: '本科生教学',
            dataIndex: 'teachU',
            align:'center',
            sorter: (a, b) => a.teachU - b.teachU,
            width:120,
            customRender: (text, row, index) => {
                if(row.teachU+row.teachG+row.teachD < row.minTeach || row.resScore < row.minResearch || row.serviceScore < row.minService){
                    return <p style='color:red;text-align:right'> {text} </p>
                }
                return <p style='text-align:right'>{text}</p>
            },
        },
        {
            title: '全日制研究生教学',
            dataIndex: 'teachG',
            sorter: (a, b) => a.teachG - b.teachG,
            align:'center',
            width:130,
            customRender: (text, row, index) => {
                if(row.teachU+row.teachG+row.teachD < row.minTeach || row.resScore < row.minResearch || row.serviceScore < row.minService){
                    return <p style='color:red;text-align:right'> {text} </p>
                }
                return <p style='text-align:right'>{text}</p>
            },
        },
        {
            title: '博士后合作导师',
            dataIndex: 'teachD',
            align:'center',
            sorter: (a, b) => a.teachD - b.teachD,
            width:130,
            customRender: (text, row, index) => {
                if(row.teachU+row.teachG+row.teachD < row.minTeach || row.resScore < row.minResearch || row.serviceScore < row.minService){
                    return <p style='color:red;text-align:right'> {text} </p>
                }
                return <p style='text-align:right'>{text}</p>
            },
        },
        {
            title: '规定科研分（最低值）',
            dataIndex: 'minResearch',
            sorter: (a, b) => a.minResearch - b.minResearch,
            align:'center',
            width:150,
            customRender: (text, row, index) => {
                if(row.teachU+row.teachG+row.teachD < row.minTeach || row.resScore < row.minResearch || row.serviceScore < row.minService){
                    return <p style='color:red;text-align:right'> {text} </p>
                }
                return <p style='text-align:right'>{text}</p>
            },
        },
        {
            title: '科研业绩教分',
            dataIndex: 'resScore',
            align:'center',
            sorter: (a, b) => a.resScore - b.resScore,
            width:120,
            customRender: (text, row, index) => {
                if(row.teachU+row.teachG+row.teachD < row.minTeach || row.resScore < row.minResearch || row.serviceScore < row.minService){
                    return <p style='color:red;text-align:right'> {text} </p>
                }
                return <p style='text-align:right'>{text}</p>
            },
        },
        {
            title: '规定公共服务分（最低值）',
            dataIndex: 'minService',
            sorter: (a, b) => a.minService - b.minService,
            align:'center',
            width:160,
            customRender: (text, row, index) => {
                if(row.teachU+row.teachG+row.teachD < row.minTeach || row.resScore < row.minResearch || row.serviceScore < row.minService){
                    return <p style='color:red;text-align:right'> {text} </p>
                }
                return <p style='text-align:right'>{text}</p>
            },
        },
        {
            title: '公共服务总分',
            dataIndex: 'serviceScore',
            sorter: (a, b) => a.serviceScore - b.serviceScore,
            align:'center',
            width:120,
            customRender: (text, row, index) => {
                if(row.teachU+row.teachG+row.teachD < row.minTeach || row.resScore < row.minResearch || row.serviceScore < row.minService){
                    return <p style='color:red;text-align:right'> {text} </p>
                }
                return <p style='text-align:right'>{text}</p>
            },
        },
        {
            title: '担任新进教师指导教师',
            dataIndex: 'guideNew',
            sorter: (a, b) => a.guideNew - b.guideNew,
            align:'center',
            width:150,
            customRender: (text, row, index) => {
                if(row.teachU+row.teachG+row.teachD < row.minTeach || row.resScore < row.minResearch || row.serviceScore < row.minService){
                    return <p style='color:red;text-align:right'> {text} </p>
                }
                return <p style='text-align:right'>{text}</p>
            },
        },
        {
            title: '公共服务（本科生）',
            dataIndex: 'examU',
            sorter: (a, b) => a.examU - b.examU,
            align:'center',
            width:120,
            customRender: (text, row, index) => {
                if(row.teachU+row.teachG+row.teachD < row.minTeach || row.resScore < row.minResearch || row.serviceScore < row.minService){
                    return <p style='color:red;text-align:right'> {text} </p>
                }
                return <p style='text-align:right'>{text}</p>
            },
        },
        {
            title: '公共服务分值（研究生）',
            dataIndex: 'publicService',
            sorter: (a, b) => a.publicService - b.publicService,
            align:'center',
            width:160,
            customRender: (text, row, index) => {
                if(row.teachU+row.teachG+row.teachD < row.minTeach || row.resScore < row.minResearch || row.serviceScore < row.minService){
                    return <p style='color:red;text-align:right'> {text} </p>
                }
                return <p style='text-align:right'>{text}</p>
            },
        },
        {
            title: '公共服务分值（外事与重大会务）',
            dataIndex: 'publicEventService',
            sorter: (a, b) => a.publicEventService - b.publicEventService,
            align:'center',
            width:160,
            customRender: (text, row, index) => {
                if(row.teachU+row.teachG+row.teachD < row.minTeach || row.resScore < row.minResearch || row.serviceScore < row.minService){
                    return <p style='color:red;text-align:right'> {text} </p>
                }
                return <p style='text-align:right'>{text}</p>
            },
        },
        {
            title: '评定等级（ABCD）',
            dataIndex: 'grade',
            align:'center',
            sorter: (a, b) => a.grade - b.grade,
            width:150,
            customRender: (text, row, index) => {
                if(row.teachU+row.teachG+row.teachD < row.minTeach || row.resScore < row.minResearch || row.serviceScore < row.minService){
                    return <p style='color:red;text-align:right'> {text} </p>
                }
                return <p style='text-align:right'>{text}</p>
            },
        },
        {
            title: '公共服务分值（其他）',
            dataIndex: 'publicOtherService',
            sorter: (a, b) => a.publicOtherService - b.publicOtherService,
            align:'center',
            width:160,
            customRender: (text, row, index) => {
                if(row.teachU+row.teachG+row.teachD < row.minTeach || row.resScore < row.minResearch || row.serviceScore < row.minService){
                    return <p style='color:red;text-align:right'> {text} </p>
                }
                return <p style='text-align:right'>{text}</p>
            },
        },
        {
            title: '本科生教书育人卓越贡献奖',
            dataIndex: 'cotentU',
            sorter: (a, b) => a.cotentU - b.cotentU,
            align:'center',
            width:160,
            customRender: (text, row, index) => {
                if(row.teachU+row.teachG+row.teachD < row.minTeach || row.resScore < row.minResearch || row.serviceScore < row.minService){
                    return <p style='color:red;text-align:right'> {text} </p>
                }
                return <p style='text-align:right'>{text}</p>
            },
        },
        {
            title: '研究生教书育人卓越贡献奖',
            dataIndex: 'cotentG',
            sorter: (a, b) => a.cotentG - b.cotentG,
            align:'center',
            width:200,
            customRender: (text, row, index) => {
                if(row.teachU+row.teachG+row.teachD < row.minTeach || row.resScore < row.minResearch || row.serviceScore < row.minService){
                    return <p style='color:red;text-align:right'> {text} </p>
                }
                return <p style='text-align:right'>{text}</p>
            },
        },
        {
            title: '科学研究卓越奖励',
            dataIndex: 'cotentO',
            sorter: (a, b) => a.cotentO - b.cotentO,
            align:'center',
            width:200,
            customRender: (text, row, index) => {
                if(row.teachU+row.teachG+row.teachD < row.minTeach || row.resScore < row.minResearch || row.serviceScore < row.minService){
                    return <p style='color:red;text-align:right'> {text} </p>
                }
                return <p style='text-align:right'>{text}</p>
            },
        },
        ,
        {
            title: '考核结果',
            dataIndex: 'assessResult',
            align:'center',
            sorter: (a, b) => a.assessResult - b.assessResult,
            width:130,
            customRender: (text, row, index) => {
                if(text == 0){
                    text = '不合格'
                }else if(text == 1){
                    text = '合格'
                }else if(text == 2){
                    text = '优秀'
                }
                if(row.teachU+row.teachG+row.teachD < row.minTeach || row.resScore < row.minResearch || row.serviceScore < row.minService){
                    return <p style='color:red;text-align:center'> {text} </p>
                }
                return <p style='text-align:center'>{text}</p>
            },
        },
        {
            title: ' 备注',
            dataIndex: 'comments',
            align:'center',
            ellipsis:true,
            width:500,
            customRender: (text, row, index) => {
                if(row.teachU+row.teachG+row.teachD < row.minTeach || row.resScore < row.minResearch || row.serviceScore < row.minService){
                    return <p title={text} style='color:red;text-align:right'> {text} </p>
                }
                return <p title={text} style='text-align:right'>{text}</p>
            },
        }
        ,
        {
            title: '申诉状态',
            dataIndex: 'complaintStatus',
            align:'center',
            width:100,
            customRender: (text, row, index) => {
                if(text == 'commit'){
                    text = '申诉中'
                }
                if(text == 'replied'){
                    text = '已回复'
                }
                if(row.teachU+row.teachG+row.teachD < row.minTeach || row.resScore < row.minResearch || row.serviceScore < row.minService){
                    return <p style='color:red;text-align:right'> {text} </p>
                }
                return <p style='text-align:right'>{text}</p>
            },
        },
        {
            title: '确定状态',
            dataIndex: 'confirmStatus',
            align:'center',
            width:100,
            customRender: (text, row, index) => {
                return text == 'Y' ? '已确认' : '未确认'
            },
        }

    ],
                data:[],
                loading: false,
                pagination:{
                    pageSizeOptions: ['10', '20', '30', '50', '100'],
                    showSizeChanger:true,
                    showTotal:total=>'共'+total+'条数据',
                    pageSize: 10,
                    current: 1,
                    total:0,
                },
                selectedRowKeys: [],
                searchFrom:{
                    size: '',
                    current: '',
                    departmentCode:'',
                    teacherName:'',
                    courseName:'',
                    schoolYear:'',
                    semester:'',
                },
                xbArr:[],
                xxArr:[],
                kclbArr:[],
                permissions:[],
                year:'',
                yearShowOne:false,
                departmentTree:[],
                bkdyArr:[],
                bkdyqx:'',
                zcArr:[],
                teacherId:'',
                season:{'3':'C','4':'C','5':'C','6':'D','7':'D','8':'D','9':'A','10':'A','11':'A','12':'B','1':'B','2':'B'}
            }
        },
        watch:{
            '$route':{
                handler(newVal,oldVal){
                    if(newVal.path === '/admin/faculty/allowance'){
                        this.fetch()
                    }
                },
                deep:true,
                immediate:true
            }
        },
        mounted () {
            this.permissions=this.$store.state.user.permissions==null?[]:this.$store.state.user.permissions;
            getDicts({dataCode:'XY',status:true}).then(res=>{
                this.xbArr=res.data.dicts;
            })
            getDicts({dataCode:'CAMPUS',status:true}).then(res=>{
                this.xxArr=res.data.dicts;
            })
            getDicts({dataCode:'KCLB',status:true}).then(res=>{
                this.kclbArr=res.data.dicts;
            })
            getDicts({dataCode:'ZC',status:true}).then(res=>{
                this.zcArr=res.data.dicts;
            })
            getDicts({dataCode:'BKDYSZ',status:true}).then(res=>{
                this.bkdyArr=res.data.dicts;
                console.log(this.bkdyArr[0].simpleName)
                console.log(this.bkdyArr[1].simpleName)

                if(new Date().getTime() >= new Date(this.bkdyArr[0].simpleName).getTime()){
                    let now = new Date().getTime()
                    let startDate = new Date(this.bkdyArr[0].simpleName).getTime()
                    let days = parseInt(now - startDate)/(1000 * 60 * 60 * 24)
                    this.bkdyqx = Math.ceil(parseInt(this.bkdyArr[1].simpleName) - days)
                }
            })
            this.searchFrom.schoolYear=(getSchoolYear()-1)+'-'+(getSchoolYear())
            this.year=(getSchoolYear()-1)+''
            // this.searchFrom.semester=this.year+this.season[new Date().getMonth()+1]
            // this.searchFrom.semester=getSemester()
            // queryDepartmentTreeList().then(res => {
            //     this.departmentTree = res.data[0].children
            // })
            getDicts({dataCode:'XY',status:true}).then(res=>{
                this.departmentTree=res.data.dicts;
            })
            this.fetch()
        },
        methods:{
            cancel(){
                cancel(this.teacherId,this.searchFrom.schoolYear).then(res=>{
                    if(res.data.success){
                        this.$notification['success']({
                            message: '成功',
                            description:'取消确认成功',
                        });
                    }else{
                        this.$notification['error']({
                            message: '失败',
                            description:res.data.errorMessage,
                        });
                    }
                })
            },
            selectedCheck(){
                selectedCheck()
            },
            exportTable(){
                // var obj=this.deepCopy(this.searchFrom);
                // delete obj.size;
                // delete obj.current;
                // obj.idList=this.selectedRowKeys;
                exportTable(this.searchFrom).then(res => {
                    window.open(this.$store.state.axiosUrl+'/api-f/statics/tempFileDirectory/'+res.data)
                })
            },  
            filterOption(input, option) {
                return (
                    option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
                );
            },
            onClickRow(record,index){
                return {
                    on: { // 事件
                        click: (event) => {
                            this.teacherId=record.teacherId
                            this.onSelectChange([record.id])
                        }
                    },

                }  
            },
            handleTableChange(pagination){
                this.selectedRowKeys=[];
                const pager = { ...this.pagination };
                pager.current = pagination.current;
                pager.pageSize = pagination.pageSize;
                this.pagination = pager;
                this.fetch();
            },
            fetch() {
                this.loading = true;
                this.searchFrom.size=this.pagination.pageSize;
                this.searchFrom.current=this.pagination.current;
                list(this.searchFrom).then(res=>{
                    this.pagination.total = res.data.total;
                    this.data = res.data.records;

                    this.data.forEach(e=>{

                        if(e.textBookCount > 0){
                            e.textBookCount = '是'
                        }else{
                            e.textBookCount = '-'
                        }
                        if(e.examEvaluateCount > 0){
                            
                        }else{
                            e.examEvaluateCount ='-'
                        }
                        if(e.advanceExamCount > 0){
                            e.advanceExamCount = '是'
                        }else{
                            e.advanceExamCount = '-'
                        }
                        if(e.parallelClass=='commit'){
                            e.parallelClass = '已提交'
                        }else if(e.parallelClass=='reject'){
                            e.parallelClass = '已驳回'
                        }else if(e.parallelClass=='approved'){
                            e.parallelClass = '系主任已审批'
                        }else if(e.parallelClass == null ||e.parallelClass == ''){
                            e.parallelClass = '-'
                        }
                        if(e.examScore != null){
                            
                        }else{
                            e.examScore ='-'
                        }
                    })
                    this.loading = false;
                })
            },
            searchList(){
                this.pagination.current=1;
                this.fetch()
            },
            exportExcel(){
                exportExcel(this.searchFrom).then(res => {
                    window.open(this.$store.state.axiosUrl+'/api-f/statics/tempFileDirectory/'+res.data)
                })
            },
            remove(id){
                del(id).then(res=>{
                    if(res.data.success){
                        this.$notification['success']({
                            message: '成功',
                            description:'删除业绩津贴成功',
                        });
                        this.fetch()
                    }else{
                        this.$notification['error']({
                            message: '失败',
                            description:res.data.errorMessage,
                        });
                    }
                })
            },
            // 弹出日历和关闭日历的回调
            openChangeOne(status) {
                    if (status){
                        this.yearShowOne =  true
                    }
                },
            // 得到年份选择器的值
            panelChangeOne(value) {
                this.year=this.getTimeStr(value._d,'yyyy')
                this.searchFrom.schoolYear=this.year+'-'+(this.year-0+1);
                this.searchFrom.semester='';
                this.yearShowOne = false;
            },
            onSelectChange(selectedRowKeys) {
                this.selectedRowKeys = selectedRowKeys;
                console.log(selectedRowKeys)
            },
            xzjxzl(){
                if(this.selectedRowKeys.length>0){
                    this.$router.push('/admin/undergraduate/quality/classroom/info?type=add&courseId='+this.selectedRowKeys[0])
                }else{
                    this.$notification['info']({
                        message: '提示',
                        description:'请选择课程后再关联教材',
                    });
                }
            },
            examsEarly(){
                if(this.selectedRowKeys.length>0){
                    this.$router.push('/admin/undergraduate/culture/examsearly/info?type=add&courseId='+this.selectedRowKeys[0])
                }else{
                    this.$notification['info']({
                        message: '提示',
                        description:'请选择课程后再进行提前考',
                    });
                }
            },
            parallelClass(){
                if(this.selectedRowKeys.length>0){
                    this.$router.push('/admin/undergraduate/culture/parallelClass/info?type=add&courseId='+this.selectedRowKeys[0])
                }else{
                    this.$notification['info']({
                        message: '提示',
                        description:'请选择课程后再进行平行班考试',
                    });
                }
            },
            spotCheck(){
                if(this.selectedRowKeys.length>0){
                    this.$router.push('/admin/undergraduate/quality/spotcheck/info?type=add&courseId='+this.selectedRowKeys[0]+'&kch='+this.courseId)
                }else{
                    this.$notification['info']({
                        message: '提示',
                        description:'请选择课程后再进行试卷抽查',
                    });
                }
            },
            exchange(){
                if(this.selectedRowKeys.length>0){
                    this.$router.push('/admin/undergraduate/culture/exchange/info?type=add&courseId='+this.selectedRowKeys[0])
                }else{
                    this.$notification['info']({
                        message: '提示',
                        description:'请选择课程后再进行调代课',
                    });
                }
            },
            courseInfo(){
                if(this.selectedRowKeys.length>0){
                    this.$router.push('/admin/undergraduate/culture/course/info?type=answer&id='+this.selectedRowKeys[0])
                }else{
                    this.$notification['info']({
                        message: '提示',
                        description:'请选择课程后再进行答疑修改',
                    });
                }
            },
            booksInfo(){
                if(this.selectedRowKeys.length>0){
                    let row
                    this.data.forEach((item)=>{
                        if(item.id == this.selectedRowKeys[0]){
                            row = item
                            if(item.classTime.indexOf('全英语') > 0){
                                row['languageName'] = '英文'
                            }else{
                                row['languageName'] = '中文'
                            }
                        }
                    })
                    this.$router.push('/admin/undergraduate/culture/books/info?type=look&courseId='+row.courseId+'&semester='+row.semester+'&languageName='+row.languageName)
                }else{
                    this.$notification['info']({
                        message: '提示',
                        description:'请选择课程后再查看教材',
                    });
                }
            }
        }
    }
</script>
<style scoped>
    /* >>> .ant-table-thead > tr > th {
        padding: 5px !important;
    }

    >>> .ant-table-tbody > tr > td {
        padding: 5px !important;
    } */

    .search-box
    {
        padding-bottom: 24px;
        border-bottom: 1px solid rgba(151,151,151,0.60);
        margin-bottom: 10px;
    }
    
    .search-box p
    {
        display: inline-block;
    }
    .search-box .right-btn
    {
        float: right;
        margin-left: 1rem;
    }
    .search-box .input-box{
        margin-right: 1rem;
        width: 10rem;
    }

    .search-box-1
    {
        margin-bottom: 10px;
    }

    .search-box-1 p
    {
        display: inline-block;
    }
    .search-box-1 .right-btn
    {
        float: right;
        margin-left: 1rem;
    }
    .search-box-1 .input-box{
        margin-right: 1rem;
        width: 10rem;
    }
    /* .ant-table-wrapper >>> .ant-table-thead > tr > th,
    .ant-table-wrapper >>> .ant-table-tbody > tr > td{
        padding: 14px;
    } */
    .action-btn{
        color: #40a9ff;
        display: inline-block;
    }
    /* .ant-table-wrapper .show-input{
        height: 23px;
        line-height: 23px;
    }
    .ant-table-wrapper .show-input >>> .ant-select-selection{
        background-color: transparent;
        border: none;
        color: rgba(0, 0, 0, 0.65);
    }
    .ant-table-wrapper .show-input >>> .ant-select-arrow{
        display: none;
    }
    .ant-dropdown-link{
        display: inline-block;
        font-size: 0.9rem;
    } */
    .operation-box{
        display: flex;
        margin-bottom: 10px;
    }

    .operation-box .btn{
        margin-right: 1rem;
    }
</style>
